export var navigationItemsSelector = function navigationItemsSelector(state) {
  return state.core.navigationMenu.mastheadNavigationItems;
};
export var isModalOpenSelector = function isModalOpenSelector(state) {
  return state.digitalCore.childWindows.childWindows.size > 0;
};
export var isGlobalSearchActive = function isGlobalSearchActive(state) {
  return state.core.globalSearch.open;
};